import { useState } from "react";

export const useDeactivateModal = (messages, onDeactivate, userEmail, kreditor, deactivateKreditor) => {

    const [dialogVisible, setDialogVisible] = useState(false)

    const cancelHandler = e => {
        setDialogVisible(false)
    }

    const acceptHandler = e => {
        onDeactivate(e)
        setDialogVisible(false)   
    }

    const showDialog = async () => {
        setDialogVisible(true);
    };

    return {dialogVisible, showDialog, cancelHandler, messages, acceptHandler, userEmail, kreditor, deactivateKreditor}

}